module.exports = __webpack_public_path__ + "6e32e160.svg";